import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { Helmet } from "react-helmet"
import { getSegmentAnalyticsSnipet } from "../../lib/utils"
import { DOMParser } from "xmldom"

export const SEO = ({ title, description, keywords, ogImage, ogType, location, headScripts }: any) => {
  const data = useStaticQuery(graphql`
        query {
          configuration: drupalSiteConfiguration {
            siteName
            icon {
              url
            }
          }
          site {
            siteMetadata {
              siteColor
              siteUrl
            }
          }
        }
      `)
  const pageTitle = title;
  const pageDescription = description;
  //const pageTitle = `${title} - ${data.configuration?.siteName}`;
  //const pageDescription = description ?? "";
  const segmentAnalyticsSnipet = getSegmentAnalyticsSnipet();

  var locationOrigin = null;
  const siteUrl = data.site?.siteMetadata?.siteUrl;
  if (siteUrl?.match('\/$')?.index) {
    locationOrigin = siteUrl.substr(0, siteUrl?.match('\/$')?.index);
  }
  else if (siteUrl) {
    locationOrigin = siteUrl;
  }

  let drupalHeadScripts = undefined
  if (headScripts && headScripts.trim().length > 0) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(headScripts.replaceAll("\n","").replaceAll("\r",""), 'text/html');
    drupalHeadScripts = Array.from(doc.childNodes)
  }
  
  return (
    <Helmet>
      <html lang="en" />
      <meta charSet={"utf-8"} />
      <title>{pageTitle}</title>
      <meta name="apple-mobile-web-app-title" content={pageTitle} />
      <meta name="referrer" content="strict-origin-when-cross-origin" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="agility_timestamp" content={new Date().toLocaleString()} />
      <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      <meta name="description" content={pageDescription} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="og:description" content={pageDescription} />
      <meta name="keywords" content={keywords} />
      <meta name="theme-color" content={data.site?.siteMetadata?.siteColor} />
      {data.configuration?.icon?.url && (
        <link rel="icon" href={data.configuration?.icon?.url} />
      )}
      {location && (
        <link rel="canonical" href={`${locationOrigin}${location.pathname}`} />
      )}
      {ogImage && <meta property="og:image" content={ogImage} />}
      {ogImage && <meta property="twitter:image" content={ogImage} />}
      {ogType && <meta property="og:type" content={ogType} />}
      {segmentAnalyticsSnipet && <script id="segment-analytics">{segmentAnalyticsSnipet}</script>}
      {process.env.GATSBY_LISTHUB_PROVIDER_ID && (
        <script type="text/javascript">
          {
            `
                (function (l, i, s, t, h, u, b) {
                  l['ListHubAnalyticsObject'] = h; l[h] = l[h] || function () {
                      (l[h].q = l[h].q || []).push(arguments)
                  }, l[h].d = 1 * new Date(); u = i.createElement(s),
                  b = i.getElementsByTagName(s)[0]; u.async = 1; u.src = t; b.parentNode.insertBefore(u, b)
              })(window, document, 'script', '//tracking.listhub.net/la.min.js', 'lh');
    
              lh('init', {provider: '${process.env.GATSBY_LISTHUB_PROVIDER_ID}', test: false});
    
              function sendListHubEmailEventSubmission(mlsId, zipCode, exclusive) {            
                  if (exclusive) {
                      lh('submit', 'AGENT_EMAIL_SENT', { mlsn: mlsId, zip: zipCode });                  
                  } else {
                      lh('submit', 'OFFICE_EMAIL_SENT', { mlsn: mlsId, zip: zipCode });                  
                  }
              }            
                `
          }
        </script>
      )}
      {drupalHeadScripts?.map((element: any, index: number) => (
        <script key={index} type={element.getAttribute("type")} id={element.getAttribute("id")}>
          {`
            ${element.textContent}
          `}
        </script>
      ))}
    </Helmet>
  )
}

export default SEO